import { HttpService } from '@/infra/http'
import type { TTipoProdutoEnum } from '@/types/produto'

export type TGetProdutosDisponiveisResponse = Array<{
  nome: string
  idExterno: number
  metragem: string
}>

export class GetProdutosDisponiveisService extends HttpService {
  execute = async (idExternoBloco: number, tipoDoProduto: Exclude<TTipoProdutoEnum, 'VagaPadrao'>) => {
    return this.http.get<TGetProdutosDisponiveisResponse>(
      `/api/v2/Produto/bloco/${idExternoBloco}/tipoProduto/${tipoDoProduto}/disponiveis`,
    )
  }
}
